import { render, staticRenderFns } from "./ModalAddress.vue?vue&type=template&id=f578143a&"
import script from "./ModalAddress.vue?vue&type=script&lang=js&"
export * from "./ModalAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f578143a')) {
      api.createRecord('f578143a', component.options)
    } else {
      api.reload('f578143a', component.options)
    }
    module.hot.accept("./ModalAddress.vue?vue&type=template&id=f578143a&", function () {
      api.rerender('f578143a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/User/Modal/ModalAddress.vue"
export default component.exports